import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { useCallback, useEffect } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { SaldoBancarioCadastroForm } from "../../../schemas/SaldoBancario_cadastro/SaldoBancario_cadastro";
import { DefaultFormMoneyInput } from "../../../../../../common/components/default_form_money_input";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";

/**
 * TransferenciaSaldoBancario
 */

type Props = {
    open: boolean,
    saving: boolean,
    ddlBancos: DropDown[],
    hookForm: UseFormReturn<SaldoBancarioCadastroForm>,
    onSubmit: (form: SaldoBancarioCadastroForm) => void,
    onClose: () => void,

};

export const TransferenciaSaldoBancarioModal = ({
    open,
    saving,
    ddlBancos,
    hookForm,
    onSubmit,
    onClose,

}: Props) => {

    useEffect(() => {
        if (open) {
            hookForm.setValue('cadastroMovimento', false);
        }
    }, [
        open,
        hookForm,
    ]);

    const handleSubmit = useCallback((form: SaldoBancarioCadastroForm) => {
        if (!saving)
            onSubmit(form);

    }, [saving, onSubmit]);

    const handleClose = useCallback(() => {
        if (!saving)
            onClose();

    }, [saving, onClose]);

    return (

        <Dialog
            open={open}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: hookForm.handleSubmit(handleSubmit),
                }
            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Cadastrar Transferência entre Bancos
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}>
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <div className="w-full bg-white p-4 rounded-2xl shadow-sm">
                                <div className="grid grid-cols-1 gap-4">
                                    <div className="flex items-center justify-between">
                                        <label className="font-medium text-gray-700">Banco Selecionado:</label>
                                        <div className="w-full">
                                            <DefaultFormAutocomplete
                                                name='idBancoPagamento'
                                                label='Banco selecionado:'
                                                readOnly={true}
                                                options={ddlBancos.filter(x => x.id === hookForm.getValues('idBancoPagamento'))}
                                                getOptionKey={x => x.id}
                                                getOptionLabel={x => x.title}
                                                reactHookForm={hookForm}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full">
                                <DefaultFormAutocomplete
                                    name='idBancoTransferencia'
                                    label='Banco para Transferência:'
                                    readOnly={saving}
                                    options={ddlBancos.filter(x => x.id !== hookForm.getValues('idBancoPagamento'))}
                                    getOptionKey={x => x.id}
                                    getOptionLabel={x => x.title}
                                    reactHookForm={hookForm}
                                />
                            </div>

                            <DefaultFormMoneyInput
                                name='valor'
                                label='Valor a Transferir:'
                                required
                                readOnly={saving}
                                reactHookForm={hookForm}
                            />

                            <FormDatePickerInput
                                name='dataTransferencia'
                                required={true}
                                label='Data Transferência:'
                                readOnly={false}
                                reactHookForm={hookForm} />


                        </>
                    </FormContainer>
                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-end justify-end flex px-4 pb-4 gap-4">

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog >
    );
}